import { useUk } from '../../../hooks'
import { ScrollContainer } from '../../ScrollContainer'

import * as styles from './AuthLayout.module.css'

function AuthLayout({ children }) {
  const {
    bg_image: { origin: bgImage },
  } = useUk()

  return (
    <div
      className={styles.AuthLayout}
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <ScrollContainer className={styles.scrollContainer}>
        {children}
      </ScrollContainer>
    </div>
  )
}

export default AuthLayout
